export interface TowProFormValues {
  address: string;
  latitude: number | null;
  longitude: number | null;
  region_id: string;
  /** ID of the selected municipality reason, held as a string for the select. */
  tow_reason_id: string;
  /** IDs of the selected sub-reasons of {@link tow_reason_id}. */
  tow_subreason_ids: string[];
  related_call: string;
  vin: string;
  make: string;
  model: string;
  vehicle_year: string;
  color: string;
  license_plate_number: string;
  license_plate_state: string;
  incident_number: string;
  agency_id: string;
  officer_name: string;
  badge_number: string;
  owner_first_name: string;
  owner_last_name: string;
  owner_phone: string;
  owner_street: string;
  owner_apt: string;
  owner_city: string;
  owner_state: string;
  owner_zip: string;
  notes: string;
}

export const TOWPRO_INITIAL_FORM_VALUES: TowProFormValues = {
  address: '',
  latitude: null,
  longitude: null,
  region_id: '',
  tow_reason_id: '',
  tow_subreason_ids: [],
  related_call: '',
  vin: '',
  make: '',
  model: '',
  vehicle_year: '',
  color: '',
  license_plate_number: '',
  license_plate_state: '',
  incident_number: '',
  agency_id: '',
  officer_name: '',
  badge_number: '',
  owner_first_name: '',
  owner_last_name: '',
  owner_phone: '',
  owner_street: '',
  owner_apt: '',
  owner_city: '',
  owner_state: '',
  owner_zip: '',
  notes: '',
};

export interface TowProSelectOption {
  value: string;
  label: string;
}

export const VIN_LENGTH = 17;
